import React, { type ReactNode } from 'react'

import { Spinner16 } from '../Spinner'

type Props = {
  state: 'loading' | string | false | null | undefined
  children: ReactNode
}

export function InternalButtonContent({ children, state }: Props) {
  const isLoading = state === 'loading'

  return (
    <span
      css={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <span
        css={[
          {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          },
          // When in the loading state, we render the normal children with `visibility: hidden`
          // in order to reserve space for them in the DOM, to prevent layout shift when we
          // switch out of the loading state.
          isLoading && {
            visibility: 'hidden',
          },
        ]}
      >
        {children}
      </span>

      {isLoading && (
        <span css={{ display: 'block', position: 'absolute' }}>
          <Spinner16 />
        </span>
      )}
    </span>
  )
}
